import React, { Fragment } from "react";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import { Paper, DialogActions, Button } from "@material-ui/core";

function InboxArticle(props) {
  const { onClose, selectedArticle, open } = props;

  const handleClose = () => {
    onClose(selectedArticle);
  };

  return (
    <Dialog
      maxWidth={"lg"}
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open || false}
    >
      {selectedArticle && selectedArticle.article_content && (
        <Paper style={{ padding: "10px" }}>
          {selectedArticle &&
            selectedArticle.article_content &&
            selectedArticle.article_content.date && (
              <Fragment>
                <h2>Date:</h2>{" "}
                {selectedArticle.article_content.date.split("T")[0]}
              </Fragment>
            )}
          <br />
          <br />
          <h2>Content:</h2>{" "}
          {selectedArticle && selectedArticle.article_content && (
            <p
              dangerouslySetInnerHTML={{
                __html: selectedArticle.article_content.content.replace(
                  /(<br\s*\/?>){2,}/gi,
                  "<br>"
                )
              }}
            />
          )}
        </Paper>
      )}
      <DialogActions>
        {" "}
        <Button onClick={handleClose} variant="contained" color="secondary">
          CLOSE
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default InboxArticle;
